import { type MylensesManagementPageView } from "@snapchat/blizzard-schema";

export interface ManagementPageViewEventData {
    event: MylensesManagementPageView["event_name"];
}

export const createManagementPageViewEvent = (
    { event }: ManagementPageViewEventData,
    sessionId: string,
): MylensesManagementPageView => ({
    event_name: event,
    mylenses_session_id: sessionId,
});
